import { BackgroundVariant, ScreenBackground } from 'core/flow/entities';
import { useIsMobile } from 'core/theme_deprecated/hooks';
import Image from '../Image';
import { AbsoluteBackgroundContainer } from './styled';

type QuizBackgroundProps = {
  backgroundImage?: ScreenBackground;
  variant?: BackgroundVariant;
  className?: string;
};

const QuizBackground = ({ backgroundImage, variant = 'light', className }: QuizBackgroundProps) => {
  const { isMobile } = useIsMobile();

  if (!backgroundImage) {
    return <AbsoluteBackgroundContainer variant={variant} className={className} />;
  }

  return (
    <AbsoluteBackgroundContainer variant={variant} className={className}>
      <Image
        layout="fill"
        objectFit="cover"
        objectPosition="top"
        quality={90}
        src={isMobile ? backgroundImage.mobileImage.src : backgroundImage.desktopImage.src}
        alt={isMobile ? backgroundImage.mobileImage.alt : backgroundImage.desktopImage.alt}
        priority
      />
    </AbsoluteBackgroundContainer>
  );
};

export default QuizBackground;
